import { render, staticRenderFns } from "./awQuestion.vue?vue&type=template&id=eb43a5b0&scoped=true&"
import script from "./awQuestion.vue?vue&type=script&lang=js&"
export * from "./awQuestion.vue?vue&type=script&lang=js&"
import style0 from "./awQuestion.vue?vue&type=style&index=0&id=eb43a5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb43a5b0",
  null
  
)

export default component.exports